import { render, staticRenderFns } from "./OrdersScheduled.vue?vue&type=template&id=04cd348b&scoped=true&"
import script from "./OrdersScheduled.vue?vue&type=script&lang=js&"
export * from "./OrdersScheduled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd348b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
